<div>
  <mat-checkbox [checked]="seaMapVisibilitySignal()" (change)="updateSeaMap($event.checked)">
    Open Sea Map Layer
  </mat-checkbox>
</div>

<div>
  <mat-form-field appearance="outline">
    <mat-label>Gebco Bathymetric</mat-label>
    <mat-select
      placeholder="Gebco Bathymetric"
      [value]="selectedBathyBaseMapLayerSignal()"
      (selectionChange)="updateSelectedBathyBaseMapLayer($event.value)"
    >
      @for (option of gebcoBathyBaseMapLayers; track option.layer) {
        <mat-option [value]="option.layer">
          {{ option.year }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
